import { Col, Row } from "antd";
import cuid from "cuid";
import { Formik } from "formik";
import { defaultsDeep, get } from "lodash";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { PROCESS_CONFIG_TYPES, TEMPLATES } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "../validation";

const General = ({
  formRef,
  dirtyRef,
  setIsDirty,
  TABS,
  data,
  onSubmit,
  type,
  name,
  theme,
  config,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const FORM = t("FORM", { returnObjects: true });
  const TEMPLATES_LABELS = t("TEMPLATES", { returnObjects: true });
  const TEMPLATES_THEMES = t("TEMPLATES_THEMES", { returnObjects: true });

  return (
    <Formik
      innerRef={(formik) => {
        formRef.current = formik;
      }}
      initialValues={{
        type,
        name,
        theme,
        description: data.description || "",
      }}
      onSubmit={async (values) => {
        await onSubmit({
          ...values,
          skills: data.skills,
          config: data.config,
          attributionType: defaultsDeep(
            config.find(
              ({ type }) => type === PROCESS_CONFIG_TYPES.ATTRIBUTION_TYPE,
            ),
            {
              id: cuid(),
              type: PROCESS_CONFIG_TYPES.ATTRIBUTION_TYPE,
              value: null,
            },
          ),
          processStatuses: data.processStatuses,
          insurancePlans: data.insurancePlans?.map(({ id }) => id),
        });
        setIsDirty((prev) => ({ ...prev, [TABS.GENERAL]: false }));
      }}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
      )}
    >
      {({ values: generalValues, dirty, ...generalFormProps }) => {
        if (dirtyRef.current !== dirty) {
          dirtyRef.current = dirty;
          setIsDirty((prev) => ({ ...prev, [TABS.GENERAL]: dirty }));
        }
        return (
          <Card type="simple" head={false} title={FORM.GENERAL_INFO}>
            <div className="grid--2">
              <Input
                placeholder={FORM.NAME}
                label={FORM.NAME}
                {...bindInputProps({
                  name: "name",
                  values: generalValues,
                  ...generalFormProps,
                })}
              />

              <Select
                options={Object.keys(TEMPLATES).map((value) => ({
                  label: TEMPLATES_LABELS[value],
                  value,
                }))}
                placeholder={FORM.TYPE}
                label={FORM.TYPE}
                {...bindInputProps({
                  name: "type",
                  values: generalValues,
                  ...generalFormProps,
                })}
              />

              <Select
                options={Object.keys(
                  get(TEMPLATES[get(generalValues, "type")], "THEMES", {}),
                ).map((key) => ({
                  label: TEMPLATES_THEMES[key],
                  value: key,
                }))}
                placeholder={FORM.THEME}
                label={FORM.THEME}
                {...bindInputProps({
                  name: "theme",
                  values: generalValues,
                  ...generalFormProps,
                })}
              />

              <Input
                placeholder={FORM.DESCRIPTION}
                label={FORM.DESCRIPTION}
                {...bindInputProps({
                  name: "description",
                  values: generalValues,
                  ...generalFormProps,
                })}
              />
            </div>
          </Card>
        );
      }}
    </Formik>
  );
};

export default General;
